import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { OrganizationDetailsProps } from '../OverviewDetails.types'

import { Avatar, Button, CardDashboard, CardContent, Spacer, Flex } from '@percent/lemonade'
import { EditFilesModal } from './EditFilesModal'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useQuery, useOrganisationsAccess } from '@percent/admin-dashboard/common/hooks'
import styles from './Files.module.scss'

export function Files({ organization, refresh }: OrganizationDetailsProps) {
  const { adminService } = useServices()
  const { canUploadImages } = useOrganisationsAccess()

  const [{ data: files }] = useQuery(
    adminService.getOrganisationFiles,
    { id: organization.id },
    {
      skip: !organization.id
    }
  )

  const [editFilesDialogState, setEditFilesDialogState] = useState(false)
  const handleEditFilesDialog = () => {
    setEditFilesDialogState(prevState => !prevState)
  }
  const { t } = useTranslation()

  return (
    <>
      <CardDashboard
        title={t('typography.files')}
        action={
          canUploadImages && (
            <Button onClick={handleEditFilesDialog} variant="secondary" data-testid="files-details-edit-button">
              {t('typography.editFiles')}
            </Button>
          )
        }
      >
        {files?.length === 0 && <CardContent testId="files-details-no-files">{t('typography.noFiles')}</CardContent>}
        {files?.length > 0 &&
          files.map((file, index) => (
            <>
              <CardContent title={t('typography.file')} testId="files-details-files">
                <Avatar image={file.url} alt={file.description} size="large" />
              </CardContent>
              <CardContent title={t('typography.dimensionsRatio')} testId="dimensions-files">
                <span>
                  {file.dimensions.width} x {file.dimensions.height} ({file.dimensions.aspectRatio})
                </span>
              </CardContent>
              <CardContent title={t('typography.description')} testId="description-files">
                <Flex direction="row" gap={16} wrap="wrap">
                  <Flex direction="column" gap={2}>
                    <span>{file.description ? file.description : t('status.na')}</span>
                  </Flex>
                </Flex>
              </CardContent>
              {index !== files.length - 1 && (
                <>
                  <hr className={styles.divider} />
                  <Spacer size={2} axis="vertical" />
                </>
              )}
            </>
          ))}
      </CardDashboard>
      <Spacer size={6} axis="vertical" />
      <EditFilesModal
        open={editFilesDialogState}
        onClose={handleEditFilesDialog}
        organization={organization}
        refresh={refresh}
      />
    </>
  )
}
